export function SwitchCanadaUS() {
    const switchContainer = document.getElementById('lang-version-switch')
    const switchSelect = document.getElementById('switch-select')

    function toggleSelect() {
        const isSelectOpen = switchSelect.getAttribute('data-open') === 'true'

        if (isSelectOpen) {
            switchSelect.setAttribute('hidden', '')
            switchSelect.setAttribute('data-open', 'false')
            switchContainer.classList.remove('switch__wrapper--open')
        } else {
            switchSelect.removeAttribute('hidden')
            switchSelect.setAttribute('data-open', 'true')
            switchContainer.classList.add('switch__wrapper--open')
        }
    }

    function setCurrentYear() {
        const yearElement = document.getElementById('current-year')
        if (!yearElement) return
    
        yearElement.textContent = new Date().getFullYear()
    }

    setCurrentYear()

    switchContainer.addEventListener('click', toggleSelect)
}